/* NEVE — Main JS */

document.addEventListener('DOMContentLoaded', () => {

  // ─── Mobile Menu ───
  const burger  = document.querySelector('.header__burger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close');

  if (burger && mobileMenu) {
    burger.addEventListener('click', () => mobileMenu.classList.add('is-open'));
    mobileClose?.addEventListener('click', () => mobileMenu.classList.remove('is-open'));
    mobileMenu.addEventListener('click', e => {
      if (e.target === mobileMenu) mobileMenu.classList.remove('is-open');
    });
  }

  // ─── Announcement bar dismiss ───
  const dismissBtn = document.querySelector('.announcement-bar__dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', () => {
      document.querySelector('.announcement-bar')?.remove();
    });
  }

});

// ─── Cart Quantity Buttons ───
function updateCartQuantity(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function() {
    window.location.reload();
  });
}

